import { createPagedRequest } from './create-request'
import querify from '../util/querify'

export const fetchCuration = (filters) => createPagedRequest({
  url: `/api/curation?${querify(filters)}`
})
